const LOGIN = "LOGIN";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_FAILURE = "LOGIN_FAILURE";
const CLEAR_LOGIN = "CLEAR_LOGIN";
const PROFILE_SUCCESS = "PROFILE_SUCCESS";

const LoginSymbols = {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN,
  CLEAR_LOGIN,
  PROFILE_SUCCESS,
};

export default LoginSymbols;
